<template>
  <NativeDrawer
    v-model="drawerVisible"
    :title="isEdit ? '编辑科室' : '新增科室'"
    size="70%"
    direction="rtl"
    @close="handleClose"
    destroy-on-close
    :before-close="handleDrawerClose"
  >
    <div class="drawer-content">
      <NativeForm
        ref="formRef"
        :model="localFormData"
        :rules="formRules"
        label-width="120px"
        class="department-form"
      >
        <!-- 基本信息 -->
        <div class="form-section">
          <div class="section-title">
            <span class="native-icon" aria-hidden="true">•</span>
            <span>基本信息</span>
          </div>

          <NativeRow :gutter="20">
            <NativeCol :span="12">
              <NativeFormItem label="科室名称" prop="name">
                <NativeInput
                  v-model="localFormData.name"
                  placeholder="请输入科室名称"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
            <NativeCol :span="12">
              <NativeFormItem label="分类" prop="group">
                <NativeSelect
                  v-model="localFormData.group"
                  placeholder="请选择分类"
                  style="width: 100%"
                >
                  <NativeOption
                    v-for="item in categoryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </NativeSelect>
              </NativeFormItem>
            </NativeCol>
          </NativeRow>

          <NativeRow :gutter="20">
            <NativeCol :span="12">
              <NativeFormItem label="科主任" prop="director">
                <NativeInput
                  v-model="localFormData.director"
                  placeholder="请输入科主任姓名"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
            <NativeCol :span="12">
              <NativeFormItem label="科室介绍logo" prop="image">
                <NativeInput
                  v-model="localFormData.image"
                  placeholder="请输入图片路径"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
          </NativeRow>

          <NativeRow :gutter="20">
            <NativeCol :span="12">
              <NativeFormItem label="特殊科室" prop="level">
                <NativeInput
                  v-model="localFormData.level"
                  placeholder="请输入科室特点（如重点学科、特色专科）"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
            <NativeCol :span="12">
              <NativeFormItem label="类别" prop="category">
                <NativeInput
                  v-model="localFormData.category"
                  placeholder="请输入科室类别"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
          </NativeRow>

          <NativeRow :gutter="20">
            <NativeCol :span="12">
              <NativeFormItem label="门诊展示人次" prop="outpatients">
                <NativeInput
                  v-model="localFormData.outpatients"
                  placeholder="请输入门诊信息"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
            <NativeCol :span="12">
              <NativeFormItem label="联系方式" prop="contact">
                <NativeInput
                  v-model="localFormData.contact"
                  placeholder="请输入联系方式"
                  clearable
                />
              </NativeFormItem>
            </NativeCol>
          </NativeRow>
        </div>

        <!-- 介绍信息 -->
        <div class="form-section">
          <div class="section-title">
            <span class="native-icon" aria-hidden="true">•</span>
            <span>介绍信息</span>
          </div>

          <NativeFormItem label="首页科室介绍" prop="descmain">
            <NativeInput
              v-model="localFormData.descmain"
              type="textarea"
              :rows="4"
              placeholder="请输入首页科室介绍，建议50-300字"
              maxlength="300"
              show-word-limit
            />
          </NativeFormItem>

          <NativeFormItem label="科室介绍简要" prop="description">
            <NativeInput
              v-model="localFormData.description"
              type="textarea"
              :rows="4"
              placeholder="请输入科室简要介绍，建议50-300字"
              maxlength="300"
              show-word-limit
            />
          </NativeFormItem>

          <NativeFormItem label="科室详情" prop="introduce">
            <NativeInput
              v-model="localFormData.introduce"
              type="textarea"
              :rows="6"
              placeholder="请输入科室详细介绍，建议100-1000字"
              maxlength="1000"
              show-word-limit
            />
          </NativeFormItem>

          <NativeFormItem label="重点科室介绍" prop="descimp">
            <NativeInput
              v-model="localFormData.descimp"
              type="textarea"
              :rows="4"
              placeholder="请输入重点科室介绍，建议50-300字"
              maxlength="300"
              show-word-limit
            />
          </NativeFormItem>
        </div>

        <!-- 专业特色 -->
        <div class="form-section">
          <div class="section-title">
            <span class="native-icon" aria-hidden="true">•</span>
            <span>专业特色</span>
          </div>

          <NativeFormItem label="" class="features-list">
            <div
              v-for="(item, index) in localFormData.features || []"
              :key="index"
              class="feature-item"
            >
              <div class="feature-input-wrapper">
                <NativeInput v-model="item.feature" placeholder="请输入专业特色" />
              </div>
              <NativeButton
                type="danger"
                size="small"
                
                circle
                @click="removeFeature(index)"
                :disabled="(localFormData.features?.length || 0) <= 1"
                class="delete-btn"
              >
                ×
              </NativeButton>
            </div>

            <NativeButton
              type="primary"
              size="default"
              @click="addFeature"
              class="add-btn"
            >
              <span class="native-icon" aria-hidden="true">+</span>
              <span>添加专业特色</span>
            </NativeButton>
          </NativeFormItem>
        </div>

        <!-- 荣誉成就 -->
        <div class="form-section">
          <div class="section-title">
            <span class="native-icon" aria-hidden="true">•</span>
            <span>荣誉成就</span>
          </div>

          <NativeFormItem label="" class="achievements-list">
            <div
              v-for="(item, index) in localFormData.achievements || []"
              :key="index"
              class="achievement-item"
            >
              <div class="achievement-input-wrapper">
                <NativeInput
                  v-model="item.achievement"
                  placeholder="请输入荣誉成就"
                />
              </div>

              <NativeButton
                type="danger"
                size="small"
                
                circle
                @click="removeAchievement(index)"
                :disabled="(localFormData.achievements?.length || 0) <= 1"
                class="delete-btn"
              >
                ×
              </NativeButton>
            </div>

            <NativeButton
              type="primary"
              size="default"
              @click="addAchievement"
              class="add-btn"
            >
              <span class="native-icon" aria-hidden="true">+</span>
              <span>添加荣誉成就</span>
            </NativeButton>
          </NativeFormItem>
        </div>

        <!-- 科研项目 -->
        <div class="form-section">
          <div class="section-title">
            <span class="native-icon" aria-hidden="true">•</span>
            <span>诊疗项目</span>
          </div>

          <NativeFormItem label="" class="projects-list">
            <div
              v-for="(item, index) in localFormData.projects || []"
              :key="index"
              class="project-item"
            >
              <div class="project-input-wrapper">
                <NativeInput
                  v-model="item.project"
                  placeholder="请输入诊疗项目名称"
                />
              </div>
              <NativeButton
                type="danger"
                size="small"
                
                @click="removeProject(index)"
                :disabled="(localFormData.projects?.length || 0) <= 1"
                class="delete-btn"
                circle
              >
                ×
              </NativeButton>
            </div>

            <NativeButton
              type="primary"
              size="default"
              @click="addProject"
              class="add-btn"
            >
              <span class="native-icon" aria-hidden="true">+</span>
              <span>添加诊疗项目</span>
            </NativeButton>
          </NativeFormItem>
        </div>
      </NativeForm>
    </div>

    <template #footer>
      <div class="drawer-footer">
        <NativeButton @click="handleCancel" size="default">
          <span class="native-icon" aria-hidden="true">×</span>
          <span>取消</span>
        </NativeButton>
        <NativeButton
          type="primary"
          @click="handleSubmit"
          :loading="submitLoading"
          size="default"
        >
          <span class="native-icon" aria-hidden="true">✓</span>
          <span>确定</span>
        </NativeButton>
      </div>
    </template>
  </NativeDrawer>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import type {
  NativeFormInstance,
  NativeFormRules,
} from "@/components/NativeUI/types";
import type { DepartmentType } from "@/stores/departments";

// Props
const props = defineProps<{
  visible: boolean;
  isEdit: boolean;
  formData: Partial<DepartmentType>;
  submitLoading: boolean;
}>();

// Emits
const emit = defineEmits<{
  (e: "update:visible", value: boolean): void;
  (e: "submit", formData: Partial<DepartmentType>): void;
  (e: "cancel"): void;
}>();

// 表单引用
const formRef = ref<NativeFormInstance>();

// Drawer 显示状态
const drawerVisible = ref(props.visible);

// 原始数据快照(用于对比修改)
const originalData = ref<Partial<DepartmentType>>({});

const categoryOptions = ref([
  { label: "内科系统", value: "internal" },
  { label: "外科系统", value: "surgical" },
  { label: "妇科系统", value: "obgyn" },
  { label: "中医系统", value: "traditional" },
  { label: "眼耳鼻喉系统", value: "Otolaryngology" },
  { label: "门诊科室", value: "emergency" },
  { label: "医技科室", value: "medical" },
]);

// 本地表单数据(避免直接修改 props)
const localFormData = ref<Partial<DepartmentType>>({
  id: 0,
  name: "",
  category: "",
  director: "",
  contact: "",
  level: "",
  group: "",
  outpatients: "",
  image: "",
  descmain: "",
  description: "",
  introduce: "",
  descimp: "",
  features: [{ feature: "", sortOrder: 0 }],
  achievements: [{ achievement: "", level: "", sortOrder: 0 }],
  projects: [{ project: "", sortOrder: 0 }],
});

// 同步表单数据的函数
const syncFormData = () => {
  // 深拷贝原始数据作为快照
  originalData.value = JSON.parse(JSON.stringify(props.formData));

  // 同步到本地表单数据
  localFormData.value = {
    ...props.formData,
    features:
      props.formData.features && props.formData.features.length > 0
        ? JSON.parse(JSON.stringify(props.formData.features))
        : [{ feature: "" }],
    achievements:
      props.formData.achievements && props.formData.achievements.length > 0
        ? JSON.parse(JSON.stringify(props.formData.achievements))
        : [{ achievement: "", level: "" }],
    projects:
      props.formData.projects && props.formData.projects.length > 0
        ? JSON.parse(JSON.stringify(props.formData.projects))
        : [{ project: "" }],
  };
};

// 监听 visible 变化
watch(
  () => props.visible,
  (newVal) => {
    drawerVisible.value = newVal;
    // Drawer 打开时同步数据
    if (newVal) {
      syncFormData();
    }
  },
);

// 监听 isEdit 变化,重新同步数据
watch(
  () => props.isEdit,
  () => {
    if (drawerVisible.value) {
      syncFormData();
    }
  },
);

// 监听 drawerVisible 变化
watch(drawerVisible, (newVal) => {
  emit("update:visible", newVal);
});

// 表单验证规则
const formRules: NativeFormRules = {
  name: [
    { required: true, message: "请输入科室名称", trigger: "blur" },
    { min: 2, max: 50, message: "科室名称长度为2-50个字符", trigger: "blur" },
  ],
  category: [{ required: true, message: "请选择分类", trigger: "change" }],
  director: [{ required: true, message: "请输入科主任姓名", trigger: "blur" }],

  description: [
    { required: true, message: "请输入科室简要介绍", trigger: "blur" },
  ],
  introduce: [
    { required: true, message: "请输入科室详细介绍", trigger: "blur" },
  ],
};

// ==================== 专业特色操作 ====================
const addFeature = () => {
  if (!localFormData.value.features) {
    localFormData.value.features = [];
  }
  localFormData.value.features.push({
    feature: "",
    sortOrder: 0,
  });
};

const removeFeature = (index: number) => {
  if (localFormData.value.features && localFormData.value.features.length > 1) {
    localFormData.value.features.splice(index, 1);
  }
};

// ==================== 荣誉成就操作 ====================
const addAchievement = () => {
  if (!localFormData.value.achievements) {
    localFormData.value.achievements = [];
  }
  localFormData.value.achievements.push({
    achievement: "",
    level: "",
    sortOrder: 0,
  });
};

const removeAchievement = (index: number) => {
  if (
    localFormData.value.achievements &&
    localFormData.value.achievements.length > 1
  ) {
    localFormData.value.achievements.splice(index, 1);
  }
};

// ==================== 科研项目操作 ====================
const addProject = () => {
  if (!localFormData.value.projects) {
    localFormData.value.projects = [];
  }
  localFormData.value.projects.push({
    project: "",
    sortOrder: 0,
  });
};

const removeProject = (index: number) => {
  if (localFormData.value.projects && localFormData.value.projects.length > 1) {
    localFormData.value.projects.splice(index, 1);
  }
};

// 提交
const handleSubmit = async () => {
  if (!formRef.value) return;

  await formRef.value.validate((valid) => {
    if (valid) {
      // 过滤掉空项
      const data = { ...localFormData.value };
      if (!data.image) {
        localFormData.value.image = `/Departments/${localFormData.value.name}.png`;
        data.image = localFormData.value.image;
      }

      if (data.features) {
        data.features = data.features.filter((item) => item.feature.trim());
        data.features.forEach((item, index) => {
          item.sortOrder = index + 1;
        });
      }
      if (data.achievements) {
        data.achievements = data.achievements.filter((item) =>
          item.achievement.trim(),
        );
        data.achievements.forEach((item, index) => {
          item.sortOrder = index + 1;
        });
      }
      if (data.projects) {
        data.projects = data.projects.filter((item) => item.project?.trim());
        data.projects.forEach((item, index) => {
          item.sortOrder = index + 1;
        });
      }

      // 提交原始数据和变更后的数据
      emit("submit", data);
    }
  });
};

const handleDrawerClose = (done: () => void) => {
  if (window.confirm("确认是否关闭?")) done();
};

// 取消
const handleCancel = () => {
  // 重置原始数据快照
  originalData.value = {};
  emit("cancel");
  drawerVisible.value = false;
};

// 关闭抽屉
const handleClose = () => {
  // 重置原始数据快照
  originalData.value = {};
  emit("cancel");
};
</script>

<style scoped lang="scss">
.drawer-content {
  height: calc(100% - 60px); // 减去 footer 高度
  overflow-y: auto;
  padding-right: 10px;

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #dcdfe6;
    border-radius: 3px;

    &:hover {
      background-color: #c0c4cc;
    }
  }
}

.department-form {
  padding: 0 10px;

  .form-section {
    margin-bottom: 24px;
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 2px solid #dee2e6;
      font-size: 15px;
      font-weight: 600;
      color: #343a40;

      .native-icon {
        font-size: 18px;
        color: #409eff;
      }
    }
  }

  // 列表项样式（特色、成果、项目、环境）
  .features-list,
  .achievements-list,
  .projects-list,
  .environment-list {
    margin-bottom: 0;

    .feature-item,
    .achievement-item,
    .project-item,
    .environment-item {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;
      padding-right: 4px; // 为删除按钮预留空间

      &:last-child {
        margin-bottom: 0;
      }

      .feature-input-wrapper,
      .achievement-input-wrapper,
      .project-input-wrapper,
      .environment-src-wrapper {
        flex: 1;
        min-width: 0;

        :deep(input) {
          padding-right: 30px; // 为清除图标预留足够空间
        }
      }

      .achievement-level-wrapper,
      .environment-alt-wrapper {
        flex-shrink: 0;
      }

      .delete-btn {
        flex-shrink: 0;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .add-btn {
      margin-top: 12px;
      width: 100%;
    }
  }
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 0;
}

// 优化表单项间距
.native-form-item {
  margin-bottom: 18px;
}
</style>
